import { Component, OnDestroy } from '@angular/core';
import { ListViewStateService } from '../../services/list-view-state.service';

@Component({
  selector: 'app-list-view-shell',
  templateUrl: './list-view-shell.component.html',
  styleUrls: ['./list-view-shell.component.scss'],
  providers: [ListViewStateService]
})
export class ListViewShellComponent implements OnDestroy {
  constructor(private listViewState: ListViewStateService) { }

  ngOnDestroy(): void {
    this.listViewState.resetListViewState();
  }
}
